import React, { memo } from 'react';
import classes from './QuestionOption.scss';
import { QuestionOptionProps } from '../types.d';

const QuestionOption = ({
  label, ignoreRightMargin, isActive, onClick,
}: QuestionOptionProps): React.ReactElement => {
  const wrapperClasses = isActive ? `${classes.wrapper} ${classes.wrapper_active}` : classes.wrapper;
  const labelClass = isActive ? `${classes.label} ${classes.label_active}` : classes.label;
  return (
    <button
      type="button"
      onClick={onClick}
      className={!ignoreRightMargin ? `${wrapperClasses} ${classes.margin_right}` : wrapperClasses}
    >
      <div className={labelClass}>{label}</div>
    </button>
  );
};

export default memo(QuestionOption);
